import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars';


const Scrollbar = (props) => {

    const renderThumb = ({ style, ...props }) => {
        const thumbStyle = {
            background: "rgba(139, 164, 206, 0.6)",
            borderRadius: "100px",
            width: 4
        };
        return <div style={{ ...style, ...thumbStyle }} {...props} />;
    };

    return(
        <Scrollbars
            autoHide
            autoHideTimeout={1000}
            autoHideDuration={200}
            renderThumbVertical={renderThumb}
            renderThumbHorizontal={() => <div />}
            {...props}
        />
    );
};

export { Scrollbar };